<template>
  <div
    v-if="isMultiformatBundle"
    class="indicator-container"
    :class="{'ml-1 my-1': useDefaultMargins}"
    :title="$t('bundledContentFormatsHint')"
    data-cy="multiformat-bundle-indicator"
  >
    <v-icon
      :class="colorClass"
      :disabled="disabled"
    >
      filter_none
    </v-icon>
    <v-icon
      class="play-icon"
      :class="colorClass"
      :disabled="disabled"
    >
      play_arrow
    </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    isMultiformatBundle: {
      type: Boolean,
      required: true,
    },
    useDefaultMargins: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    colorClass: {
      type: String,
      default: 'msr--text',
    },
  },
};
</script>

<style scoped>
.indicator-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.play-icon {
  font-size: 1rem !important;
  position: relative;
  margin-left: -17px;
  margin-right: 4px;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/MultiformatBundleIndicator.vue